import { render, staticRenderFns } from "./RecipeStatistics.vue?vue&type=template&id=227d8087&"
import script from "./RecipeStatistics.vue?vue&type=script&lang=js&"
export * from "./RecipeStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports